import { Dispatch, SetStateAction, useState } from "react";

/**
 * Backs a value that may be controlled by a prop or self-managed internally. When `controlled` is
 * provided (neither `null` nor `undefined`) the hook reports that prop value; otherwise it owns
 * local state seeded with `initialValue`. Returns the resolved value, the internal-state setter
 * (which callers should only invoke while uncontrolled), and whether the hook is controlled.
 */
export const useControllableState = <T>(
  controlled: T | null | undefined,
  initialValue: T,
): readonly [T, Dispatch<SetStateAction<T>>, boolean] => {
  const [internalValue, setInternalValue] = useState<T>(initialValue);
  const isControlled = controlled !== undefined && controlled !== null;
  return [isControlled ? (controlled as T) : internalValue, setInternalValue, isControlled];
};
